import React from 'react';
import { stats } from '../mock';

export default function Stats() {
  const bgs = ['bg-[#F4B93E]', 'bg-[#4FB3B8]', 'bg-[#E64B2B]', 'bg-[#7BB7DC]'];
  return (
    <section className="max-w-7xl mx-auto px-5 lg:px-8 py-14">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
        {stats.map((s, i) => (
          <div key={s.label} className={`${bgs[i]} rounded-2xl border-2 border-[#2C3E50] p-6 paper-shadow-sm`}>
            <div className="text-4xl lg:text-5xl font-black text-[#2C3E50]" style={{ fontFamily: 'Fraunces, serif' }}>{s.value}</div>
            <div className="mt-1 font-bold text-[#2C3E50]/80 uppercase tracking-wider text-xs">{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
